import { get } from 'lodash';
import { ANTRAGS_FORMULAREN } from '../../../../../lib/constants/constant';
import { TreeNodeType } from '../../../../../lib/types/types';
import { assignIdsToStruc } from '../../../../../utils/helper';
import { VNTreeStructureDefault } from './default-content/DefaultTreeStructureVerwendungnachweis';
import { VNTreeStructureEmobLis } from './emob-lis/VNTreeStructureEmobLis';

// import schemas
import KostenpositionSchema from '../../../../../lib/paths/kostenposition_FULL_Paths.json';
import VerwendungsnachweissSchema from '../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsnachweissSchema.attributes;
const KP_P = KostenpositionSchema.attributes;

export const TreeStructureVerwendungsnachweis = (application: any, kostenKategories: any, readOnly: boolean, alleVerwendungsnachweise?: any[]) => {
	const antragsFormular = get(application, VN_P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path, '');

	// Tree Structure
	let treeNodes: TreeNodeType[] = [];

	// All Kosten Arten
	const allKostenArtZuAntrag = get(application, VN_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []).map((ele: any) =>
		get(ele, KP_P.Allgemein_Kostenposition.path)
	);

	switch (antragsFormular) {
		case ANTRAGS_FORMULAREN.EmobLis:
			treeNodes = VNTreeStructureEmobLis(application, kostenKategories, readOnly, alleVerwendungsnachweise);
			break;
		default:
			treeNodes = VNTreeStructureDefault(application, allKostenArtZuAntrag);
	}

	return assignIdsToStruc(treeNodes);
};

// const nachSchuessigExtraStructure = (zahlungsweise: string, 'application: any) => {
// 	let nodes: TreeNodeType[] = [];

// 	if (zahlungsweise === ZAHLUNGSWEISE.Nachschus) {
// 		nodes = [
// 			// {
// 			// 	label: 'Bankdaten',
// 			// 	content: <BankdatenVN />,
// 			// 	formStruc: getFormStrucBankdatenVN(application),
// 			// },
// 			// {
// 			// 	label: 'Abruf',
// 			// 	content: <AbrufVN />,
// 			// 	formStruc: getFormStrucAbrufVN(application),
// 			// },
// 			{
// 				label: 'Erklärungen',
// 				content: <ErklaerungMAundVN />,
// 				formStruc: getFormStrucErklaerungMAundVN(),
// 			},
// 		];
// 	}
// 	return nodes;
// };
// const PersonalkostenStructure = (kostenArt: any[], application: any, readOnly: boolean) => {
// 	let nodes: TreeNodeType[] = [];

// 	if (kostenArt.includes(KOSTEN_ARTEN.Personalkosten)) {
// 		nodes = [
// 			{
// 				label: 'Personalkosten',
// 				content: <ApplicationHeading title='Personalkosten' description={PLATZHALTER_TEXT} />,
// 				children: GetPersonalKostenVN(application, readOnly),
// 				hasComment: hasAnyNachweisPositionComment(
// 					readOnly,
// 					application,
// 					P.Verwendungsnachweis_Nachweispositions.path,
// 					'KostenArt',
// 					0,
// 					NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
// 					KOSTEN_ARTEN.Personalkosten
// 				),
// 			},
// 			{
// 				label: 'Personalkosten Übersicht',
// 				content: <PersonalKostenUebersichtVN />,
// 			},
// 		];
// 	}
// 	return nodes;
// };
// const SachkostenStructure = (kostenArt: any[], application: any, readOnly: boolean) => {
// 	let nodes: TreeNodeType[] = [];
// 	if (kostenArt.includes(KOSTEN_ARTEN.Sachkosten)) {
// 		nodes = [
// 			{
// 				label: 'Sachkosten',
// 				content: <ApplicationHeading title='Sachkosten' description={PLATZHALTER_TEXT} />,
// 				children: GetSachkostenVN(application, readOnly),
// 				hasComment: hasAnyNachweisPositionComment(
// 					readOnly,
// 					application,
// 					P.Verwendungsnachweis_Nachweispositions.path,
// 					'KostenArt',
// 					0,
// 					NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
// 					KOSTEN_ARTEN.Sachkosten
// 				),
// 			},
// 			{
// 				label: 'Sachkosten Übersicht',
// 				content: <SachkostenUebersichtVN />,
// 			},
// 		];
// 	}
// 	return nodes;
// };
// const InvestitionskostenStructure = (antragsFormular: any, kostenArt: any[], kostenKategories: any[], application: any, readOnly: boolean) => {
// 	let nodes: TreeNodeType[] = [];
// 	if (kostenArt.includes(KOSTEN_ARTEN.Investitionskosten)) {
// 		if (antragsFormular === ANTRAGS_FORMULAREN.EmobLis) {
// 			nodes = GetInvestitionskostenVNLIS(application, kostenKategories, readOnly);
// 		} else {
// 			nodes = [
// 				{
// 					label: 'Investitionskosten',
// 					content: <ApplicationHeading title='Investitionskosten' description={PLATZHALTER_TEXT} />,
// 					children: GetInvestitionskostenVN(application, readOnly),
// 					hasComment: hasAnyNachweisPositionComment(
// 						readOnly,
// 						application,
// 						P.Verwendungsnachweis_Nachweispositions.path,
// 						'KostenArt',
// 						0,
// 						NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
// 						KOSTEN_ARTEN.Investitionskosten
// 					),
// 				},
// 				{
// 					label: 'Investitionskosten Übersicht',
// 					content: <InvestitionskostenUebersichtVN />,
// 				},
// 			];
// 		}
// 	}
// 	return nodes;
// };
// const Reisekostenstructure = (kostenArt: any[], application: any, readOnly: boolean) => {
// 	let nodes: TreeNodeType[] = [];
// 	if (kostenArt.includes(KOSTEN_ARTEN.Reisekosten)) {
// 		nodes = [
// 			{
// 				label: 'Reisekosten',
// 				content: <ApplicationHeading title='Reisekosten' description={PLATZHALTER_TEXT} />,
// 				children: GetReisekostenVN(application, readOnly),
// 				hasComment: hasAnyNachweisPositionComment(
// 					readOnly,
// 					application,
// 					P.Verwendungsnachweis_Nachweispositions.path,
// 					'KostenArt',
// 					0,
// 					NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
// 					KOSTEN_ARTEN.Investitionskosten
// 				),
// 			},
// 			{
// 				label: 'Reisekosten Übersicht',
// 				content: <ReisekostenUebersichtVN />,
// 			},
// 		];
// 	}
// 	return nodes;
// };
// const Eigenmittelstructure = (antragsFormular: any, kostenArt: any[], application: any, readOnly: boolean) => {
// 	let nodes: TreeNodeType[] = [];
// 	if (kostenArt.includes(KOSTEN_ARTEN.Eigenmittel)) {
// 		if (antragsFormular === ANTRAGS_FORMULAREN.EmobLis) {
// 			nodes = [
// 				{
// 					label: 'Eigen- und Drittmittel',
// 					content: (
// 						<EigenmittelVNLIS kostentraeger={KOSTENTRAEGER.Antragsteller} unternehmenId={get(getLocalstorageToken(), 'organisationId')} />
// 					),
// 				},
// 				{
// 					label: 'Eigen- und Drittmittel Übersicht',
// 					content: <EigenmittelUebersichtVNLIS />,
// 				},
// 			];
// 		} else {
// 			nodes = [
// 				{
// 					label: 'Eigen- und Drittmittel',
// 					content: <ApplicationHeading title='Eigen- und Drittmittel' description={PLATZHALTER_TEXT} />,
// 					children: GetEigenmittelVN(application, readOnly),
// 					hasComment: hasAnyNachweisPositionComment(
// 						readOnly,
// 						application,
// 						P.Verwendungsnachweis_Nachweispositions.path,
// 						'KostenArt',
// 						0,
// 						NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
// 						KOSTEN_ARTEN.Eigenmittel
// 					),
// 				},
// 				{
// 					label: 'Eigen- und Drittmittel Übersicht',
// 					content: <EigenmittelUebersichtVN />,
// 				},
// 			];
// 		}
// 	}
// 	return nodes;
// };
// const FinanzierungsStructure = (antragsFormular: string) => {
// 	if (antragsFormular === ANTRAGS_FORMULAREN.EmobLis) {
// 		return [
// 			{
// 				label: 'Ausgaben und Finanzierungsplan',
// 				content: <FinanzierungsPlanVNLIS />,
// 			},
// 		];
// 	} else {
// 		return [
// 			{
// 				label: 'Ausgaben und Finanzierungsplan',
// 				content: <FinanzierungsPlanVN />,
// 			},
// 		];
// 	}
// };
